export default __webpack_public_path__ + "static/media/closedJob.40fe5904.svg";